import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from './language.service';
import { LanguageInterceptor } from './language.interceptor';

@NgModule({
    imports: [HttpClientModule, CommonModule, TranslateModule],
    providers: [
        LanguageService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LanguageInterceptor,
            multi: true,
        },
    ],
})
export class LanguageModule {}
